// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo } from 'react'
import { EllipsisTextPopup } from '../ellipsis-text-popup/EllipsisTextPopup'

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const FullTextPositionToolTip = memo(({ toolTipContainerPositionStyle, additionalStyle, title }) => {
  const toolTipCustomStyle = {
    ...toolTipContainerPositionStyle,
    ...additionalStyle,
  }

  // @ts-expect-error TS2741 -- MIGRATION: not approved, fix when encountered
  return <EllipsisTextPopup style={toolTipCustomStyle}>{title}</EllipsisTextPopup>
})

export default FullTextPositionToolTip
